import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Container = styled(({ active, ...props }) => <motion.div {...props} />)`
  min-width: 50px;
  color: #1c165b;
  background-color: white;
  transition: background-color, color ease-in 200ms, box-shadow ease-out 200ms;
`
